module.exports = __webpack_public_path__ + "static/media/kfc-24-4.cbc1297f.jpg";